import { keyframes } from "@mui/system";
import { alpha } from "@mui/material/styles";

/** Layout compartilhado do modal BPe — tamanho fixo em todas as etapas. */
export const BPE_WIZARD_MAX_WIDTH = "xl";

/**
 * Guia visual discreto: um "halo" pulsante suave que direciona a atenção do
 * atendente para o próximo campo/ação a preencher, sem poluir a interface.
 * O pulso é desligado quando o usuário prefere menos movimento.
 */
export const bpeGuidePulse = keyframes`
  0%, 100% { box-shadow: 0 0 0 0 rgba(25, 118, 210, 0); }
  50% { box-shadow: 0 0 0 4px rgba(25, 118, 210, 0.16); }
`;

/** Halo para campos de formulário (TextField/Autocomplete outlined) ativos. */
export const bpeGuideInputSx = (theme) => ({
  borderRadius: 1,
  animation: `${bpeGuidePulse} 2.2s ease-in-out infinite`,
  "@media (prefers-reduced-motion: reduce)": {
    animation: "none",
    boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.18)}`,
  },
  "& .MuiOutlinedInput-root fieldset": {
    borderColor: theme.palette.primary.main,
  },
});

/** Halo para o botão de ação principal quando a etapa está pronta para avançar. */
export const bpeGuideButtonSx = {
  animation: `${bpeGuidePulse} 2.2s ease-in-out infinite`,
  "@media (prefers-reduced-motion: reduce)": { animation: "none" },
};

export const BPE_WIZARD_HEIGHT = "min(94vh, 940px)";

export const bpeWizardPaperSx = {
  height: BPE_WIZARD_HEIGHT,
  maxHeight: BPE_WIZARD_HEIGHT,
  width: "min(96vw, 1400px)",
  maxWidth: "min(96vw, 1400px)",
  display: "flex",
  flexDirection: "column",
};

export const bpeWizardTitleSx = {
  py: 1,
  px: 2,
  flexShrink: 0,
};

export const bpeWizardContentSx = {
  px: 2,
  pt: 0.5,
  pb: 1.5,
  flex: 1,
  minHeight: 0,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
};

export const bpeWizardStepperSx = {
  flexShrink: 0,
  pt: 0.25,
  pb: 1,
  "& .MuiStepLabel-label": {
    fontSize: "0.72rem",
    mt: "4px !important",
  },
  "& .MuiStepIcon-root": {
    width: 26,
    height: 26,
  },
};

export const bpeWizardStepBodySx = {
  flex: 1,
  minHeight: 0,
  overflow: "auto",
  display: "flex",
  flexDirection: "column",
};

export const bpeWizardStepBodyFillSx = {
  flex: 1,
  minHeight: 0,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
};

/**
 * Conteúdo do passo dentro da região rolável (passos sem lista própria).
 * Não cria scrollbar próprio: quem rola é a região externa, levando junto
 * os avisos/recomendações acima — assim o conteúdo não fica espremido.
 */
export const bpeWizardStepInnerSx = {
  flex: 1,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
};

export const bpeWizardActionsSx = {
  px: 2,
  py: 1,
  gap: 1,
  flexWrap: "wrap",
  flexShrink: 0,
  borderTop: 1,
  borderColor: "divider",
  bgcolor: "background.paper",
  alignItems: "center",
  minHeight: 56,
};
